export default {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};
